/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */
import { createReducer } from 'reduxsauce';
import { ProdRcpt01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const prodRcpt01ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
});

export const prodRcpt01FetchProdRcpt01Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const prodRcpt01FetchProdRcpt01Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const prodRcpt01AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const prodRcpt01RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const prodRcpt01SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const prodRcpt01CreateProdRcpt01Loading = (state, { boolean }) => ({
  ...state,
  createIsLoading: boolean
});

export const prodRcpt01CreateProdRcpt01Success = (state, { newDocuments }) => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: [],
  newDocuments
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [ProdRcpt01Types.PROD_RCPT01_RESET_TIMESTAMP]: prodRcpt01ResetTimestamp,
  [ProdRcpt01Types.PROD_RCPT01_FETCH_PROD_RCPT01_LOADING]: prodRcpt01FetchProdRcpt01Loading,
  [ProdRcpt01Types.PROD_RCPT01_FETCH_PROD_RCPT01_SUCCESS]: prodRcpt01FetchProdRcpt01Success,
  [ProdRcpt01Types.PROD_RCPT01_ADD_SELECTED_DOCUMENTS]: prodRcpt01AddSelectedDocuments,
  [ProdRcpt01Types.PROD_RCPT01_REMOVE_SELECTED_DOCUMENTS]: prodRcpt01RemoveSelectedDocuments,
  [ProdRcpt01Types.PROD_RCPT01_SET_WORKSPACE_VISIBLE]: prodRcpt01SetWorkspaceVisible,
  [ProdRcpt01Types.PROD_RCPT01_CREATE_PROD_RCPT01_LOADING]: prodRcpt01CreateProdRcpt01Loading,
  [ProdRcpt01Types.PROD_RCPT01_CREATE_PROD_RCPT01_SUCCESS]: prodRcpt01CreateProdRcpt01Success
});
